import React, { useState, useContext, useEffect } from 'react';
import { Card, Row, Col, Modal, Form, Navbar, Container, Nav, Button, Table } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { MDBInput } from 'mdb-react-ui-kit';
import API from '../../utils/api';
import $ from 'jquery';
import moment from 'moment';
import { Link } from 'react-router-dom';
import PsContext from '../../context';
import { PSListItem } from '../../comp';
import { lettersOnly, integerIndMobile } from '../../utils';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const tdStyle = { border: '1px solid grey', borderCollapse: 'collapse', padding: '3px' }

const CollectionReportStaffWise = () => {

	const context = useContext(PsContext);
	const [loading, setIsLoading] = useState(false);
	const [staffData, setStaffData] = useState([]);
	const [plasticData, setPlasticData] = useState([]);
	const [collectionData, setCollectionData] = useState([]);
	const [fromdate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
	const [todate, setToDate] = useState(moment().format("YYYY-MM-DD"));

	const printDocument = () => {

		var content = document.getElementById("printdata");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	useEffect(() => {
		liststaff();
		//listplastic();
		listsales();
	}, []);

	const listsales = () => {
		try {
			setIsLoading(true);
			var form = new FormData();
			form.append('acyear', context.acyear.id);
			form.append('fromdate', fromdate);
			form.append('todate', todate);
			API.post('v1/plastic/listcollectionbydate', form).then(res => {
				if (res['data'].status == '1') {
					var d = res['data'].data;
					setCollectionData(d);
					setIsLoading(false);
				}
				else {
					setCollectionData([]);
					setIsLoading(false);
				}
			});
		}
		catch (error) {
			setIsLoading(false);
		}
	};

	const listplastic = (event) => {
		event.preventDefault();
		try {

			API.post('v1/plastic/listchartplastic', $('#list').serialize()).then(res => {
				if (res['data'].status == '1') {
					var d = res['data'].data;
					setPlasticData(d);
					setIsLoading(false);
				}
				else {
					setIsLoading(false);
				}
			});
		}
		catch (error) {

		}
	};

	// const listplastic = () => {
	// 	try {
	// 		setIsLoading(true);
	// 		var form = new FormData();
	// 		form.append('acyear', context.acyear.id);
	// 		API.post('v1/plastic/listplastic', form).then(res => {
	// 			if (res['data'].status == '1') {
	// 				var d = res['data'].data;
	// 				setPlasticData(d);
	// 				setIsLoading(false);
	// 			}
	// 			else {
	// 				setIsLoading(false);
	// 			}
	// 		});
	// 	}
	// 	catch (error) {
	// 		setIsLoading(false);
	// 	}
	// };

	const liststaff = () => {
		try {
			setIsLoading(true);
			API.get('v1/user/list').then(res => {
				if (res['data'].status == '1') {
					var d = res['data'].data;
					setStaffData(d);
					setIsLoading(false);
				}
				else {
					setIsLoading(false);
				}
			});
		}
		catch (error) {
			setIsLoading(false);
		}
	};


	const getPlastic = (sid, pid) => {
		var d = collectionData;
		var kg = 0;
		var index = d.findIndex(function (obj) {
			return (obj.staff_id == sid && obj.plastic_id == pid);
		});
		if (index > -1) {
			kg = d[index].kg;
		}
		return kg;
	}

	const getTotalPlastic = (pid) => {
		var d = collectionData;
		var kg = 0;
		d.filter(function (obj) {
			if (obj.plastic_id == pid) {
				kg += parseFloat(obj.kg);
			}
		});
		return kg;
	}

	const onFromChange = (event) => {

		var fromdate = $("#fromdate").val();
		setFromDate(fromdate);
		var toMinDate = moment(fromdate).format("YYYY-MM-DD");
		if (fromdate != '') {
			$("#todate").attr('min', toMinDate);
		}
	};

	return (
		<>
			<div className="container">
				<Navbar bg="white" expand="md">
					<Container>
						<Navbar.Brand >Staff Wise Collection Report</Navbar.Brand>
					</Container>
				</Navbar><br />
				<Row>
					<Col md={12}>
						<Form onSubmit={listplastic} method='post' id="list">
							<Row>
								<Col md={9}>
								</Col>
								<Col md={2} className='ms-0'>
									<select className='form-control sm' name="type">
										<option value="">Select Type</option>
										<option value="plastic kg">Plastic Kg</option>
										<option value="others kg">Non Plastic Kg</option>
										<option value="others pcs">Non Plastic Piece</option>
									</select>
								</Col>
								<Col md={1}>
									<Button type="submit" size='sm' className='mt-1' variant="success">Search</Button>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
				{plasticData.length > 0 ? <Row style={{ margin: '10px' }}>
					<Col md={4}>
						<label>From Date:</label>
						<MDBInput
							type="date"
							id="fromdate"
							defaultValue={fromdate}
							onChange={onFromChange}
						/>
					</Col>
					<Col md={4}>
						<label>To Date:</label>
						<MDBInput
							type="date"
							id="todate"
							defaultValue={todate}
							onChange={(e) => { setToDate(e.target.value) }}
						/>
					</Col>
					<Col md={4}>
						<Button type="submit" className="mt-3" onClick={listsales}>Submit</Button>&nbsp;
						<Button type="button" className="mt-3" variant="warning" onClick={printDocument}>Print</Button>&nbsp;
						<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="download-table-xls-button btn mt-3 btn-info"
							table="table-to-xls"
							filename="Staff Wise Collection Report"
							sheet="staffwisecollection"
							buttonText="Export as XLS" />
					</Col>
					<Col md={12} className="mt-3" id="printdata">
						<Table bordered responsive style={tdStyle} id="table-to-xls">
							<thead className="text-center">
								<tr>
									<th style={tdStyle} colSpan={2 + plasticData.length}>
										<span style={{ fontSize: '18px' }}>Staff Wise Collection Report ( {moment(fromdate).format("DD-MM-YYYY")} to {moment(todate).format("DD-MM-YYYY")} )</span>
									</th>
								</tr>
								<tr>
									<th width="5%" style={tdStyle}><b>S.No</b></th>
									<th width="10%" style={tdStyle}><b>Staff Name</b></th>
									{plasticData.map((item, i) => {
										return <th width="10%" style={tdStyle}><b>{item.short_name}</b></th>
									})}
								</tr>
							</thead>
							<tbody className="text-center">
								{staffData.map((item, i) => {
									return <tr>
										<td style={tdStyle}>{i + 1}</td>
										<td style={tdStyle} align="left">{item.name}</td>
										{plasticData.map((items, j) => {
											return <td style={tdStyle} align="right">{getPlastic(item.id, items.id)}</td>
										})}
									</tr>
								})}
								<tr>
									<td colSpan="2" align="right" style={tdStyle}><b>Total</b></td>
									{plasticData.map((items, j) => {
										return <td style={tdStyle} align="right"><b>{getTotalPlastic(items.id).toFixed(2)}</b></td>
									})}
								</tr>
							</tbody>
						</Table>
						<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
					</Col>
				</Row> : ''}
			</div>
		</>
	);
};
export default CollectionReportStaffWise;